import React from 'react';

export default function ExperienceIcon() {
  return (
    <svg
      className="svg-icon"
      width="44px"
      height="37px"
      viewBox="0 0 44 37"
      role="img"
      aria-labelledby="experience-icon-title"
    >
      <title id="experience-icon-title">Experience Icon</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#19A6A8" fillRule="nonzero">
          <path
            d={
              'M40.3333047,5.70007125 L31.1666953,5.70007125 ' +
              'L31.1666953,3.80001781 C31.1666953,1.70429467 29.5222813,0 27.5,0 ' +
              'L16.5,0 C14.4778047,0 12.8333047,1.70420561 12.8333047,3.80001781 ' +
              'L12.8333047,5.69998219 L3.66669531,5.69998219 C1.64441406,5.70007125 ' +
              '0,7.40427686 0,9.5 L0,15.1999822 C0,17.2957944 1.64441406,19 ' +
              '3.66669531,19 L18.3333906,19 L18.3333906,18.0499733 ' +
              'C18.3333906,17.5248624 18.7433984,17.0999466 19.2500859,17.0999466 ' +
              'L24.7500859,17.0999466 C25.2567734,17.0999466 25.6667812,17.5248624 ' +
              '25.6667812,18.0499733 L25.6667812,19 L40.3334766,19 C42.3555859,19 ' +
              '44,17.2957944 44,15.1999822 L44,9.5 C44,7.40427686 ' +
              '42.3555859,5.70007125 40.3333047,5.70007125 Z M27.5,5.70007125 ' +
              'L16.5,5.70007125 L16.5,3.80001781 L27.5,3.80001781 ' +
              'L27.5,5.70007125 Z'
            }
          />
          <path
            d={
              'M43.4914229,19.0999117 C43.1790407,18.9400895 ' +
              '42.8057289,18.9770739 42.529956,19.1932153 C41.8782932,19.7023049 ' +
              '41.1191228,19.9711291 40.33314,19.9711291 L25.6666452,19.9711291 ' +
              'L25.6666452,22.8092594 C25.6666452,23.332185 25.2566382,23.7553325 ' +
              '24.7499517,23.7553325 L19.2499624,23.7553325 C18.7432759,23.7553325 ' +
              '18.3332689,23.332185 18.3332689,22.8092594 L18.3332689,19.9711291 ' +
              'L3.66668815,19.9711291 C2.88070531,19.9711291 2.12162086,19.7023049 ' +
              '1.46987213,19.1932153 C1.19323986,18.9752114 0.820873397,18.938227 ' +
              '0.508405257,19.0999117 C0.196968365,19.2598226 0,19.5877154 ' +
              '0,19.9471823 L0,33.2157966 C0,35.302798 1.64441085,37 ' +
              '3.66668815,37 L40.3333118,37 C42.3555032,37 44,35.3028867 ' +
              '44,33.2157966 L44,19.9471823 C44,19.5877154 43.8029457,19.2598226 ' +
              '43.4914229,19.0999117 Z'
            }
          />
        </g>
      </g>
    </svg>
  );
}
